import React, { useState, useEffect, useMemo } from 'react';
import ReportField from './report-field';
import { SingleCollapse, AEAPopOver } from "@/components/";
import { Container } from 'reactstrap';
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import Buttons from '../buttons';
import { Enums, Utilities } from "@utils";
import styles from './report-field/index.module.scss';

export interface INarrativeReport{    
    projectData: any;
    screen: string;
    activeTab: number;
}

const NarrativeReport: React.FC<INarrativeReport> = ({projectData, screen, activeTab}: INarrativeReport) => {   
    const [currentPeriod, setCurrentPeriod] = useState<any>(null);
    const [dimensionData, setDimensionData] = useState(null);
    const [reports, setReports] = useState(null);
    const [chkEnded, setChkEnded] = React.useState(false);
    const [auxScreen, setAuxScreen] = useState(screen);
    const [isCreated, setIsCreated] = useState(false);
    const [periods, setPeriods] = useState([]);

    const view: IFollowupSubproject = {
        state: {
            projectData,
            currentPeriod,
            reports,
            chkEnded,
            setDimensionData,
            setCurrentPeriod,
            setReports,
            setChkEnded,
            setIsCreated,
            setPeriods
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const fields = useMemo(() => (
        [presenter.followupLabels.get(Enums.NarrativeReportFields.sectionDeviations), 
        presenter.followupLabels.get(Enums.NarrativeReportFields.sectionRisks),  
        presenter.followupLabels.get(Enums.NarrativeReportFields.sectionSubstantialModifications),  
        presenter.followupLabels.get(Enums.NarrativeReportFields.sectionNoSubstantialModifications),  
        presenter.followupLabels.get(Enums.NarrativeReportFields.sectionOther) ]
    ), [])

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.subProjectPeriods?.length && presenter.subProjectDimensions?.length) presenter.initNarrativeReport()
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectPeriods, presenter.subProjectDimensions]);

    useEffect(() => {
        let isSubscribed = true;
        if(activeTab === 3){
            if(isCreated && presenter?.narrativeReport && dimensionData) presenter.unSetLoading()
            else presenter.keepLoading()
        }
        return () => {(isSubscribed = false)}
    }, [isCreated, presenter?.narrativeReport, dimensionData, activeTab]);

    useEffect(()=>{
        let isSubscribed = true;
        if(presenter?.narrativeReport?.followupReport && presenter.formMasters){
            presenter.getNarrativeReportData(projectData?.year)
        }
        return () => {(isSubscribed = false)}
    },[presenter?.narrativeReport, presenter.subProjectPeriods, presenter.formMasters])

    useEffect(() => {
        let isSubscribed = true;
        const canEdit = (screen === Enums.FollowupState.edit)
        if(dimensionData && canEdit) {
            let currentUser = presenter.getCurrentUser()
            let otherEdit = (!!dimensionData?.EnEdicion && currentUser.currentUser.userPrincipalName !== dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "")) || !dimensionData?.EnEdicion
            setAuxScreen(otherEdit ? Enums.FollowupState.view : screen)
        }
        return () => {(isSubscribed = false)}
    }, [dimensionData, screen]);

    let visible = presenter.loadingFinished()
    let dimensionTour = (!presenter.tourINSeen && currentPeriod) ? presenter.getTourDimension(Enums.FollowupDimensions.narrativeReport, currentPeriod) : null

    useEffect(() => {
        if(!presenter.tourINSeen && presenter.stepTourIN === 1 && visible && activeTab === 3){
            Utilities.notifyTour(presenter.followupLabels.get("NarrativeRepTourStep1"),
                presenter.followupLabels.get("tourWelcome"),
                `${presenter.followupLabels.get("tourBtnNext")} (${presenter.stepTourIN}/10)`,
                presenter.followupLabels.get("tourBtnSkip")
            )
            .then((res) => {
                if(res)presenter.changeStepTour(presenter.stepTourIN + 1, Enums.FollowupDimensions.narrativeReport);
                else presenter.toggleTour(Enums.FollowupDimensions.narrativeReport, true)
            })
        }
    }, [presenter.tourINSeen, presenter.stepTourIN, visible, activeTab]);

    const renderFields = (followupReport: any) => {
        if(followupReport?.length && currentPeriod){
            const current = followupReport.filter((report:any) => Number(report.ReportePeriodoId) === Number(currentPeriod?.Id));
            let isApproved = currentPeriod?.EstadoPeriodoCod === Enums.FollowupState.approved 
            let lastPeriod = presenter?.narrativeReport?.periods?.[presenter?.narrativeReport?.periods?.length - 1]
            let isLastPeriod =  (currentPeriod?.Id === lastPeriod?.Id)
            
            const history = (isApproved && isLastPeriod) ? followupReport : followupReport.filter((report:any) => Number(report.ReportePeriodoId) !== Number(currentPeriod?.Id));   

            let auxTourData = (!presenter.tourINSeen) ? presenter.getTourData(4, Enums.FollowupDimensions.narrativeReport) : null

            return fields.map((field:string, index:number) => {
                let question: string[] = [];
                switch(index){
                    case 0:
                        question = [Enums.NarrativeReportFields.DesviacionesExplicacion, Enums.NarrativeReportFields.DesviacionesMedidas, Enums.NarrativeReportFields.DesviacionesPlazos]
                        break;
                    case 1:
                        question = [Enums.NarrativeReportFields.RiesgosExplicaciones, Enums.NarrativeReportFields.RiesgosMedidas, Enums.NarrativeReportFields.RiesgosPlazos]
                        break;
                    case 2:
                        question = [Enums.NarrativeReportFields.ModificacionesSustanciales]
                        break;
                    case 3:
                        question = [Enums.NarrativeReportFields.ModificacionesNoSustanciales]
                        break;
                    default:
                        question = [Enums.NarrativeReportFields.OtrosComentarios]
                        break;
                }

                let isOpen = (presenter.stepTourIN === 4 || presenter.stepTourIN === 5 || (!presenter.tourINSeen && (index === 4 || presenter.stepTourIN === 1))) ? true : false

                return (
                    <SingleCollapse key={index} title={field} isOpen={isOpen} idTitle={index === 2 ? 'NarrativeRepTourStep3' : ''}>
                        <>
                            {
                                question.length > 1 ? 
                                    question.map((q, i) => {
                                        return(
                                            <SingleCollapse key={index + "-" + i} title={presenter.followupLabels.get(q)} isOpen={(presenter.stepTourIN === 4 || presenter.stepTourIN === 5) ? true : false}>
                                                <ReportField 
                                                    historyTourData={(q === Enums.NarrativeReportFields.DesviacionesExplicacion && !presenter.tourINSeen) ? auxTourData?.history : null}
                                                    data={{current: auxTourData?.current || current[0]?.[q] || '', history: !!auxTourData ? [{id: 1}] : history}} 
                                                    year={projectData?.year} 
                                                    question={q} 
                                                    periods={presenter?.narrativeReport?.periods?.length ? presenter?.narrativeReport?.periods || periods : periods} 
                                                    maxLength={2500} 
                                                    disabled={(isApproved || (auxScreen === Enums.FollowupState.view) && presenter.tourINSeen)} 
                                                    createdByLabel={presenter.followupLabels.get("narrativeCreatedByLabel")} 
                                                    noHistoryLabel={presenter.followupLabels.get("narrativeNoHistoryLabel")} 
                                                />
                                            </SingleCollapse>
                                        )
                                    })
                                : 
                                    <ReportField
                                        data={{current: current[0]?.[question[0]] || '', history:history}}
                                        year={projectData?.year} 
                                        question={question[0]} 
                                        periods={presenter?.narrativeReport?.periods} 
                                        maxLength={2500} 
                                        disabled={(isApproved || (auxScreen === Enums.FollowupState.view) && presenter.tourINSeen)} 
                                        createdByLabel={presenter.followupLabels.get("narrativeCreatedByLabel")} 
                                        noHistoryLabel={presenter.followupLabels.get("narrativeNoHistoryLabel")} 
                                    />
                            }
                        </>
                        
                    </SingleCollapse>
                );
            });
        }
        return <div></div>;
    }

    return (
        <>
            { isCreated ? 
                    (presenter.followupLabels && currentPeriod && reports?.length) ?
                        <Container fluid={true}>
                            <Buttons 
                                chkEnded={presenter.stepTourIN >= 6 ? true :chkEnded}
                                setChkEnded={setChkEnded}
                                save={presenter.saveData} 
                                check={presenter.checkData} 
                                toggleEditing={presenter.toggleEditing}
                                getPermissions={() => presenter.getReportPermissions()} 
                                dimensionData={ dimensionData} 
                                followupLabels={presenter.followupLabels} 
                                formMasters={presenter.formMasters}
                                step={4} 
                                screen={screen}
                                currentYear={projectData?.year}
                                currentPeriod={dimensionTour || currentPeriod}
                                startTour={() => presenter.toggleTour(Enums.FollowupDimensions.narrativeReport, false)}
                                stepTour={presenter.stepTourIN}
                                currentUser={presenter.getCurrentUser()} />
                            <h5 className={styles.subtitleNarrative}>{presenter.followupLabels.get("narrativeReportSubtitle")}</h5>
                            {renderFields(reports)}
                            {(visible && !presenter.tourINSeen) &&
                                <AEAPopOver
                                    popOverScroll={presenter.getScrollTour(presenter.stepTourIN, Enums.FollowupDimensions.narrativeReport)}
                                    stepPosition={presenter.getPositionTour(presenter.stepTourIN, Enums.FollowupDimensions.narrativeReport)} 
                                    visible={visible && !presenter.tourINSeen} 
                                    step={presenter.stepTourIN} 
                                    totalStep={10}
                                    changeStepTour={(step: number) => presenter.changeStepTour(step, Enums.FollowupDimensions.narrativeReport)}
                                    finishTour={() => presenter.toggleTour(Enums.FollowupDimensions.narrativeReport, true)} 
                                    labelDimension={'NarrativeRepTourStep'} 
                                    followupLabels={presenter.followupLabels}
                                /> 
                            } 
                        </Container>
                    : 
                        <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>
                            {presenter.followupLabels.get("noPeriodYearSubproyect")}
                        </div>
                : <></>
            }
        </>
    )
}

export default NarrativeReport;